var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-centered is-mobile"},[_c('div',{staticClass:"column is-two-thirds-tablet is-four-fifths-mobile mt-6"},[_c('vue-simple-markdown',{attrs:{"source":_vm.src}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }